import { usageId } from '../../../../../constants/usageid.js';
import { FrequencyPlotConfigurationSchemaIds, FrequencyPlotConfigurationTags } from '../../schemas/configuration.const.js';
export const dictionary = {
    schema: {
        [usageId(FrequencyPlotConfigurationSchemaIds.FREQUENCY_PLOT_CONFIGURATION, FrequencyPlotConfigurationTags.DEFAULT)]: {
            title: 'Frequency Plot Configuration',
            description: 'Options that apply to the Frequency Plot.',
            abbr: 'Frequency config.',
            cti: 'Set the Frequency Plot options.'
        }
    }
};
